var _g, _rect, _rect2, _rect3, _rect4, _path, _g2, _path2, _rect5, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "outlook"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 10,
    height: 14,
    rx: 2,
    fill: "#1066B5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 10,
    height: 14,
    rx: 2,
    fill: "url(#paint0_linear_2413_15007)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rectangle_2",
    x: 5,
    y: 1.5,
    width: 5,
    height: 5,
    fill: "#32A9E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rectangle_3",
    x: 5,
    y: 6.5,
    width: 5,
    height: 5,
    fill: "#167EB4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rectangle_4",
    x: 10,
    y: 6.5,
    width: 5,
    height: 5,
    fill: "#32A9E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rectangle_5",
    x: 10,
    y: 1.5,
    width: 5,
    height: 5,
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2413_15007",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 12,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3",
    d: "M4 6H14C15.1046 6 16 6.89543 16 8V12C16 13.1046 15.1046 14 14 14H6C4.89543 14 4 13.1046 4 12V6Z",
    fill: "url(#paint1_linear_2413_15007)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2413_15007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M16 6V8H15V6H16Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M16 14V7L3.5 14H16Z",
    fill: "url(#paint2_linear_2413_15007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M4 14V7L16.5 14H4Z",
    fill: "url(#paint3_linear_2413_15007)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "rectangle_6",
    d: "M4 6.5C4 4.84315 5.34315 3.5 7 3.5C8.65685 3.5 10 4.84315 10 6.5V9.5C10 11.1569 8.65685 12.5 7 12.5H4V6.5Z",
    fill: "black",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rectangle_7",
    y: 2.5,
    width: 9,
    height: 9,
    rx: 2,
    fill: "url(#paint4_linear_2413_15007)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M7 7.03463V6.95152C7 5.51108 5.96361 4.5 4.50791 4.5C3.0443 4.5 2 5.51801 2 6.96537V7.04848C2 8.48892 3.03639 9.5 4.5 9.5C5.9557 9.5 7 8.48199 7 7.03463ZM5.8212 7.04848C5.8212 8.00415 5.28323 8.57895 4.50791 8.57895C3.73259 8.57895 3.18671 7.9903 3.18671 7.03463V6.95152C3.18671 5.99584 3.72468 5.42105 4.5 5.42105C5.2674 5.42105 5.8212 6.0097 5.8212 6.96537V7.04848Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2413_15007",
    x1: 5,
    y1: 7,
    x2: 15,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2413_15007",
    x1: 4,
    y1: 12.3846,
    x2: 16,
    y2: 12.3846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2413_15007",
    x1: 16,
    y1: 10.5,
    x2: 4,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2413_15007",
    x1: 4,
    y1: 10.5,
    x2: 16,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2413_15007",
    x1: 0,
    y1: 7,
    x2: 9,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookSmall);
export default __webpack_public_path__ + "static/media/outlook-small.c39f6702e2a23ee5372bb2247fa40291.svg";
export { ForwardRef as ReactComponent };